import {connect} from 'react-redux';
import RestrictionsTab from './RestrictionsTab.jsx'; 
 
export default connect()(RestrictionsTab);



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/RestrictionsTabContainer.jsx